// extracted by mini-css-extract-plugin
export var optionGrid = "_8p-7";
export var optionList = "_8p-6";
export var questionsBlock = "_8p-9";
export var spacer = "_8p-5";
export var stepCenteredContent = "_8p-3";
export var stepInner = "_8p-0";
export var stepInnerFullWidth = "_8p-1";
export var stepInnerLockScroll = "_8p-2";
export var stepTransitionFrame = "_8p-4";
export var welcomeBlock = "_8p-8";